import { validateProps } from './props';
import { all } from 'ramda';

function validateChallenges(challenges) {
  // valid Q/A props to check against
  const validProps = ['question', 'answers'];
  // using the validateProps from utils
  const validateChallenge = validateProps(validProps);
  // check if all challenges are valid => we have questions / answers
  // otherwise run the error
  return all(validateChallenge, challenges);
}

export { validateChallenges };
